// Phase 22A — "Tracking active" chip on the SE app shell.
//
// Renders a small persistent chip that shows tracking state + queued ping
// count when offline. Never hidden — user should always know their location
// is being captured while they're on the clock.
import { MapPin } from "lucide-react";

export default function TrackingChip({ active, netStatus, queuedCount, canTrack, gpsPermission }) {
  // Not enabled at all — hide (user isn't punched in or lacks perms).
  if (!canTrack) return null;

  const denied = gpsPermission === "denied";
  const offline = netStatus === "offline";

  let color = "bg-emerald-100 text-emerald-800 border-emerald-200";
  let label = "Tracking active";
  let dot = "bg-emerald-500 animate-pulse";
  if (denied) {
    color = "bg-rose-100 text-rose-800 border-rose-200";
    label = "GPS blocked";
    dot = "bg-rose-500";
  } else if (offline && queuedCount > 0) {
    color = "bg-amber-100 text-amber-800 border-amber-200";
    label = `Queued ${queuedCount}`;
    dot = "bg-amber-500";
  } else if (!active) {
    color = "bg-neutral-100 text-neutral-600 border-neutral-200";
    label = "Tracking paused";
    dot = "bg-neutral-400";
  }

  return (
    <div
      data-testid="tracking-chip"
      className={"inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[10px] font-medium " + color}
      title={`GPS ${gpsPermission || "?"} · net ${netStatus}`}
    >
      <span className={"h-1.5 w-1.5 rounded-full " + dot} />
      <MapPin className="h-3 w-3" />
      <span>{label}</span>
    </div>
  );
}
